<script>
import idealLayPercentages from '@/layerAdmin/data/idealData.js';
import LineChart from '@/charts/components/LineChart.vue';

export default {
  components: {
    LineChart,
  },

  props: {
    batches: { type: Array, required: true },
    colorPairsPerBatch: { type: Object, required: true },
    series: { type: Array, required: true },
    minWeeks: { type: [Number, String], default: () => 0 },
    maxWeeks: { type: [Number, String], default: () => 0 },
    idealLayPercentageTypes: { type: Array, required: true },
  },

  data: function () {
    return {
      recordsFilter: record => record.age_in_weeks >= Number(this.minWeeks) && record.age_in_weeks <= Number(this.maxWeeks),
    };
  },

  computed: {
    title() { return `Laying vs Food` },
    options() {
      return {
        maintainAspectRatio: false,
      };
    },

    minAgeInDays() {
      return Math.min(
        Math.min(...this.idealLayPercentageTypes.map(x => Math.min(...Object.keys(idealLayPercentages[x].layPercentageAtWeek).map(y => y * 7)))),
        Math.min(...this.batches.map(x => Math.min(...x.records.filter(this.recordsFilter).map(y => y.age_in_days)))));
    },

    maxAgeInDays() {
      return Math.max(
        Math.max(...this.idealLayPercentageTypes.map(x => Math.max(...Object.keys(idealLayPercentages[x].layPercentageAtWeek).map(y => y * 7)))),
        Math.max(...this.batches.map(x => Math.max(...x.records.filter(this.recordsFilter).map(y => y.age_in_days)))));
    },

    ageInDayList() {
      let ages = [];
      for (let ageInDays = this.minAgeInDays; ageInDays <= this.maxAgeInDays; ageInDays++) {
        ages.push(ageInDays);
      }
      return ages;
    },

    chartData() {
      let dataSets = [];

      let xAxisLabels = this.ageInDayList.map(x => `${Number(x / 7).toFixed(0)}wk / ${x}d`);

      this.idealLayPercentageTypes.forEach(typeOfHen => {
        let idealAtWeek = idealLayPercentages[typeOfHen].layPercentageAtWeek;
        let idealWeights = this.ageInDayList.map(x => idealAtWeek[x / 7] || null);

        dataSets.push({
          label: `Ideal ${typeOfHen} Lay %`,
          backgroundColor: '#bbb',
          borderColor: '#bbb',
          pointHitRadius: 2,
          data: idealWeights,
          fill: false,
          spanGaps: true,
          borderWidth: 1,
          borderDash: [10, 5],
          pointRadius: 1,
        });
      });

      this.batches
        .forEach(batch => {
          let filteredRecords = batch.records.filter(this.recordsFilter);

          if (this.series.includes('Lay %')) {
            dataSets.push({
              label: `${batch.name} Lay %`,
              backgroundColor: this.colorPairsPerBatch[batch.id][0],
              borderColor: this.colorPairsPerBatch[batch.id][0],
              pointHitRadius: 10,
              data: this.ageInDayList.map(ageInDays => { let recordOnAge = filteredRecords.find(y => y.age_in_days === ageInDays); return recordOnAge ? (recordOnAge.lay_percentage ? Number(recordOnAge.lay_percentage).toFixed(0) : null) : null }),
              fill: false,
              spanGaps: true,
              borderWidth: 1,
              pointRadius: 1,
            });
          }

          if (this.series.includes('Feed/hen')) {
            dataSets.push({
              label: `${batch.name} Feed/hen`,
              backgroundColor: this.colorPairsPerBatch[batch.id][1],
              borderColor: this.colorPairsPerBatch[batch.id][1],
              pointHitRadius: 10,
              data: this.ageInDayList.map(ageInDays => { let recordOnAge = filteredRecords.find(y => y.age_in_days === ageInDays); return recordOnAge ? (recordOnAge.feed_grams_per_hen ? Number(recordOnAge.feed_grams_per_hen).toFixed(2) : null) : null }),
              fill: false,
              spanGaps: true,
              borderWidth: 1,
              pointRadius: 1,
            });
          }

          if (this.series.includes('Avg g/egg')) {
            dataSets.push({
              label: `${batch.name} Avg g/egg`,
              backgroundColor: this.colorPairsPerBatch[batch.id][0],
              borderColor: this.colorPairsPerBatch[batch.id][0],
              borderDash: [10, 5],
              pointHitRadius: 10,
              data: this.ageInDayList.map(ageInDays => { let recordOnAge = filteredRecords.find(y => y.age_in_days === ageInDays); return recordOnAge ? (recordOnAge.average_egg_weight_grams ? Number(recordOnAge.average_egg_weight_grams).toFixed(2) : null) : null }),
              fill: false,
              spanGaps: true,
              borderWidth: 1,
              pointRadius: 1,
            });
          }
        });

      return {
        labels: xAxisLabels,
        datasets: dataSets,
      }
    },
  },
}
</script>

<template>
  <div>
    <line-chart
      :chart-data="chartData"
      :options="options"
      :x-axis-ticks-min-rotation="60"
      :x-axis-ticks-max-rotation="60"
      :chart-title="title"
      x-axis-label="Age"
      y-axis-label="Laying % vs Food"
      style="height:1000px; max-height:70vh" />
  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/LayPercentageVsFoodChart.vue